import { saveState, setName } from "../components/util";

const schema = {
  type: "object",
  title: "Change layer name",
  properties: {
    name: { type: "string" }
  }
};

const ui = { name: { "ui:autofocus": true } };

const fn = ({
  addLayer,
  layer,
  formData,
  handleClose,
  layers,
  setContentKey,
  setState,
  state
}) => {
  const { name } = formData;
  const index = layers.findIndex(a => a._id === layer._id);
  setName(layers[index], name);
  const newState = { ...state, layers: [...layers] };
  setState(newState);
  saveState(newState);

  setContentKey(null);
};

export const changeName = { ui, schema, fn };
